const getSuccess = state => state.country.success
const getError = state => state.country.error
const getMessage = state => {
  return state.country.message
    ? state.country.message : null
}

export {
  getSuccess,
  getError,
  getMessage
}
